import SectionHeader from '../ui/SectionHeader';
import AnimatedCard from '../ui/AnimatedCard';
import MotionReveal from '../ui/MotionReveal';
import AntButton from '../ui/AntButton';
import { sectionCopy, specializations } from '../../data/portfolioData';
import { scrollToSection } from '../../utils/scrollTo';

const Aboutme = () => {
  const copy = sectionCopy.about;

  return (
    <section id="about" className="section-padding bg-ant-bg-2 text-ant-fg border-t border-ant-line-soft">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          label={copy.label}
          titleLine1={copy.titleLine1}
          titleLine2={copy.titleLine2}
          subtitle={copy.subtitle}
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-12 gap-4 lg:gap-5 mb-16">
          {specializations.map((item, index) => (
            <MotionReveal
              key={item.number}
              delay={index * 50}
              className={index === 0 ? 'sm:col-span-2 lg:col-span-7' : index === 1 ? 'lg:col-span-5' : index === 2 ? 'lg:col-span-5' : 'sm:col-span-2 lg:col-span-7'}
            >
              <AnimatedCard className="ant-glass group rounded-2xl border border-white/[0.08] bg-white/[0.02] p-7 hover:border-white/[0.14] h-full cursor-default">
                <div className="flex items-center gap-3 mb-5">
                  <span className="font-mono text-[11px] tracking-[0.2em] text-white/25">{item.number}</span>
                  <span className="h-px flex-1 bg-white/[0.08]" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-3 group-hover:text-ant-gold transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-white/45">{item.description}</p>
              </AnimatedCard>
            </MotionReveal>
          ))}
        </div>

        <MotionReveal>
          <AnimatedCard className="rounded-2xl border border-white/[0.08] bg-white/[0.02] p-8 lg:p-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 hover:border-white/[0.14]">
            <div className="max-w-2xl">
              <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-white/35 mb-5">
                {copy.aboutLabel}
              </p>
              <p className="text-white/60 leading-relaxed">{copy.aboutText}</p>
            </div>
            <AntButton variant="secondary" onClick={() => scrollToSection('contact')} className="shrink-0 w-full sm:w-auto">
              {copy.cta}
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </AntButton>
          </AnimatedCard>
        </MotionReveal>
      </div>
    </section>
  );
};

export default Aboutme;